import { originalParagraphs, remakeParagraphs } from '@/mocks/home';

export default function OriginalAndRemake() {
  return (
    <section id="original" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/60">
      <div className="max-w-6xl mx-auto">
        <div className="reveal max-w-2xl">
          <span className="text-primary-600 font-label text-sm tracking-wide">分代解读</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            从 1993 到 2011：同一个名字，两种命运
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            要理解 3D 版，得先回到它借来的那个名字。原版打下了什么底子，改编又想补上什么，两段放在一起看最清楚。
          </p>
        </div>

        <div className="mt-10 space-y-6 md:space-y-8">
          <article className="reveal grid grid-cols-1 lg:grid-cols-5 gap-5 md:gap-8 items-stretch">
            <div className="lg:col-span-2 relative min-h-[240px] lg:min-h-0 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Moody%20retro%20Hong%20Kong%20city%20street%20at%20dusk%20with%20neon%20signs%20in%20warm%20amber%20and%20peach%20tones%2C%20grainy%201990s%20film%20stock%20aesthetic%2C%20soft%20golden%20light%2C%20nostalgic%20cinematic%20atmosphere%2C%20artistic%20photography%2C%20high%20detail%2C%20no%20text&width=1000&height=750&seq=peach-original-01&orientation=landscape"
                alt="90 年代香港街景氛围，呼应原版《蜜桃成熟时》的时代质感"
                className="w-full h-full min-h-[240px] object-cover object-top"
              />
              <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-label">
                原版 · 1993
              </span>
            </div>
            <div className="lg:col-span-3 bg-background-50 border border-background-200/80 rounded-lg p-6 md:p-8">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                《蜜桃成熟时》——被反复回味的基准线
              </h3>
              <div className="mt-4 space-y-4">
                {originalParagraphs.map((text) => (
                  <p key={text} className="text-foreground-700 text-sm md:text-base leading-relaxed">
                    {text}
                  </p>
                ))}
              </div>
            </div>
          </article>

          <article id="remake" className="reveal grid grid-cols-1 lg:grid-cols-5 gap-5 md:gap-8 items-stretch">
            <div className="lg:col-span-3 bg-background-950 rounded-lg p-6 md:p-8 text-background-50 order-2 lg:order-1">
              <div className="flex items-center gap-3">
                <span className="px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs font-label">
                  3D 版 · 2011
                </span>
                <span className="text-background-50/60 text-xs font-label">正式片名常写作《蜜桃成熟时 33D》</span>
              </div>
              <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold">
                当经典 IP 换上科幻与 3D 的外衣
              </h3>
              <div className="mt-4 space-y-4">
                {remakeParagraphs.map((text) => (
                  <p key={text} className="text-background-50/80 text-sm md:text-base leading-relaxed">
                    {text}
                  </p>
                ))}
              </div>
            </div>
            <div className="lg:col-span-2 relative min-h-[240px] lg:min-h-0 rounded-lg overflow-hidden order-1 lg:order-2">
              <img
                src="https://readdy.ai/api/search-image?query=Futuristic%20neon%20sci-fi%20corridor%20with%20glowing%20pink%20and%20amber%20lights%2C%20holographic%20abstract%20shapes%2C%20wet%20reflective%20floor%2C%20retro-futurism%202010s%20style%2C%20cinematic%20glow%2C%20artistic%20high%20detail%20render%2C%20no%20text&width=1000&height=750&seq=peach-3d-future-01&orientation=landscape"
                alt="未来感霓虹场景，呼应 3D 版的科幻穿越设定"
                className="w-full h-full min-h-[240px] object-cover object-top"
              />
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}